'use client';

import type { PropsWithChildren } from 'react';
import { IconResolver, type IconType } from '../IconResolver';
import { tv } from '../_lib/utils';
import { Anchor } from '../Anchor';
import { Text } from '../Text';

const styles = tv({
	slots: {
		base: 'group relative py-1 transition-colors duration-fast',
		anchor:
			'md:transition-opacity md:duration-slow md:ease-smooth md:opacity-100 md:hover:opacity-80 before:bottom-0 before:left-0 before:right-0 before:top-0 before:absolute before:z-10',
		text: 'flex gap-2 items-center',
	},
	variants: {
		styleType: {
			brand: {
				base: 'text-text-brand hover:text-text-brand-hover',
			},
			secondary: {
				base: 'text-text-secondary hover:text-text-secondary-hover',
			},
		},
	},
});

export type LabelLinkProps = PropsWithChildren<{
	className?: string;
	copy?: string;
	href?: string;
	icon?: IconType | string;
	size?: 'md' | 'lg';
	styleType?: 'brand' | 'secondary';
}>;

export function LabelLink(props: LabelLinkProps) {
	const size = props.size ?? 'md';
	const styleType = props.styleType ?? 'brand';
	const { base, anchor, text } = styles({ styleType });

	if (props.copy === undefined) {
		return null;
	}

	const copy = (
		<div className={text()}>
			<IconResolver className={`shrink-0 ${size === 'md' ? 'w-3 h-3' : 'w-3.5 h-3.5'}`} icon={props.icon ?? 'caret-left'} />

			<Text styleType={size === 'md' ? 'label-sm' : 'label-md'}>{props.copy}</Text>
		</div>
	);

	return (
		<div className={base({ className: props.className })} data-component='LabelLink'>
			{props.href ? (
				<Anchor className={anchor()} href={props.href}>
					{copy}
				</Anchor>
			) : (
				copy
			)}
		</div>
	);
}
